(function () {
  'use strict';

  const SCRIPT_KEY = '__minQtyEnforcementInitialized';
  const ERROR_ID = 'min-qty-error-msg';

  if (window[SCRIPT_KEY]) return;
  window[SCRIPT_KEY] = true;

  function getConfig() {
    return window.minQtyConfig || { enabled: false, min: 1, productId: null };
  }

  function getProductInfoRoot() {
    const config = getConfig();
    if (!config.productId) return document.querySelector('product-info');

    return document.querySelector(`product-info[data-product-id="${config.productId}"]`) || document.querySelector('product-info');
  }

  function getQuantityInput(root = getProductInfoRoot()) {
    return root?.querySelector('quantity-input .quantity__input[name="quantity"]') || null;
  }

  function getAddToCartForm(root = getProductInfoRoot()) {
    return root?.querySelector('product-form form[data-type="add-to-cart-form"]') || null;
  }

  function getAddToCartButton(root = getProductInfoRoot()) {
    return root?.querySelector('product-form [name="add"]') || null;
  }

  function getOrCreateErrorElement(root = getProductInfoRoot()) {
    if (!root) return null;

    let errorElement = root.querySelector(`#${ERROR_ID}`);
    if (errorElement) return errorElement;

    const button = getAddToCartButton(root);
    if (!button?.parentElement) return null;

    errorElement = document.createElement('p');
    errorElement.id = ERROR_ID;
    errorElement.className = 'product-form__error-message min-qty-error-message';
    errorElement.setAttribute('role', 'alert');
    errorElement.setAttribute('aria-live', 'polite');
    errorElement.hidden = true;

    button.parentElement.insertAdjacentElement('afterend', errorElement);
    return errorElement;
  }

  function showError(message, root = getProductInfoRoot()) {
    const errorElement = getOrCreateErrorElement(root);
    if (!errorElement) return;

    errorElement.textContent = message;
    errorElement.hidden = false;
  }

  function clearError(root = getProductInfoRoot()) {
    const errorElement = root?.querySelector(`#${ERROR_ID}`);
    if (!errorElement) return;

    errorElement.hidden = true;
    errorElement.textContent = '';
  }

  function validateQuantity(input, min) {
    const value = parseInt(input.value, 10);
    return !Number.isNaN(value) && value >= min;
  }

  function syncQuantityInput(root = getProductInfoRoot()) {
    const config = getConfig();
    if (!config.enabled || !root) return;

    const input = getQuantityInput(root);
    if (!input) return;

    input.min = String(config.min);
    input.dataset.min = String(config.min);

    if (!validateQuantity(input, config.min)) {
      input.value = String(config.min);
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));

    if (input.dataset.minQtyBound !== 'true') {
      input.addEventListener('change', () => {
        const currentConfig = getConfig();
        if (!currentConfig.enabled) return;

        if (!validateQuantity(input, currentConfig.min)) {
          input.value = String(currentConfig.min);
          input.dispatchEvent(new Event('change', { bubbles: true }));
          showError(`Minimum order quantity for this product is ${currentConfig.min}.`, root);
          return;
        }

        clearError(root);
      });

      input.dataset.minQtyBound = 'true';
    }
  }

  function bindSubmitGuard(root = getProductInfoRoot()) {
    const config = getConfig();
    if (!config.enabled || !root) return;

    const form = getAddToCartForm(root);
    if (!form || form.dataset.minQtySubmitBound === 'true') return;

    form.addEventListener(
      'submit',
      (event) => {
        const currentConfig = getConfig();
        if (!currentConfig.enabled) return;

        const input = getQuantityInput(root);
        if (!input) return;

        if (validateQuantity(input, currentConfig.min)) {
          clearError(root);
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        input.value = String(currentConfig.min);
        input.dispatchEvent(new Event('change', { bubbles: true }));
        showError(`Minimum order quantity for this product is ${currentConfig.min}. Quantity has been updated.`, root);
        input.focus();
        input.select?.();
      },
      true
    );

    form.dataset.minQtySubmitBound = 'true';
  }

  function bindVariantListeners(root = getProductInfoRoot()) {
    const config = getConfig();
    if (!config.enabled || !root || root.dataset.minQtyVariantBound === 'true') return;

    root.addEventListener('change', (event) => {
      if (!event.target.closest('variant-selects, variant-radios')) return;

      clearError(root);
      window.setTimeout(() => syncQuantityInput(root), 80);
      window.setTimeout(() => syncQuantityInput(root), 250);
    });

    root.dataset.minQtyVariantBound = 'true';
  }

  function initialize(root = getProductInfoRoot()) {
    const config = getConfig();
    if (!config.enabled || !root) return;

    syncQuantityInput(root);
    bindSubmitGuard(root);
    bindVariantListeners(root);
  }

  document.addEventListener('product-info:loaded', (event) => {
    initialize(event.target.closest('product-info') || getProductInfoRoot());
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }
})();
